import { Plus } from 'lucide-react'

type Props = {
  onOpen: () => void
}

/**
 * Dashed-card affordance that opens the full Quick-Add sheet on tap.
 * Kept visually minimal so the richer add-item flow (which handles
 * category, emoji, and the pantry_items upsert) owns the UX.
 */
export function AddCustomItem({ onOpen }: Props) {
  return (
    <button
      onClick={onOpen}
      className="w-full mb-4 rounded-[14px] border border-dashed border-[#D4C4A8] bg-paper px-[14px] py-3 flex items-center gap-[10px] text-left"
    >
      <div className="flex h-6 w-6 flex-shrink-0 items-center justify-center rounded-[7px] bg-[#FBE8DB]">
        <Plus className="h-3 w-3 text-terracotta" strokeWidth={1.8} />
      </div>
      <span className="font-serif text-[13px] italic text-ink-muted flex-1">
        Need something else?
      </span>
    </button>
  )
}
